<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-text-eko-orange tw-mt-8 tw-font-bold tw-text-2xl"
      >
        Change Password
      </p>
    </div>

    <div class="tw-flex tw-flex-wrap tw--mx-3 tw-mb-6">
      <div class="tw-w-full tw-px-3 tw-mb-6 md:tw-mb-0">
        <label
          class="tw-block tw-uppercase tw-tracking-wide tw-text-left tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
          for="grid-first-password"
          >Old Password</label
        >
        <input
          class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded tw-py-3 tw-px-4 tw-leading-tight focus:tw-outline-none focus:tw-border-gray-500"
          id="grid-first-password"
          type="password"
          placeholder="********"
          v-model="data.oldPassword"
        />
        <p v-if="errors.oldPassword" class="tw-text-xs tw-text-red-500">
          Old Password field cannot be empty
        </p>
      </div>
      <div class="tw-w-full tw-px-3 tw-my-6 md:tw-mb-0">
        <label
          class="tw-block tw-uppercase tw-tracking-wide tw-text-left tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
          for="grid-conf-password"
          >New Password</label
        >
        <input
          class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded tw-py-3 tw-px-4 tw-leading-tight focus:tw-outline-none focus:tw-border-gray-500"
          type="password"
          placeholder="********"
          v-model="data.newPassword"
        />
        <p v-if="errors.newPassword" class="tw-text-xs tw-text-red-500">
          New Password field cannot be empty
        </p>
      </div>
      <div class="tw-w-full tw-px-3 tw-my-6 md:tw-mb-0">
        <label
          class="tw-block tw-uppercase tw-tracking-wide tw-text-left tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
          for="grid-conf-password"
          >Confirm Password</label
        >
        <input
          class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-border tw-border-gray-200 tw-rounded tw-py-3 tw-px-4 tw-leading-tight focus:tw-outline-none focus:tw-border-gray-500"
          type="password"
          placeholder="********"
          v-model="conf_password"
        />
        <p v-if="errors.conf_password" class="tw-text-xs tw-text-red-500">
          Passwords dont match
        </p>
      </div>
    </div>

    <div class="tw-flex tw-items-center tw-justify-between">
      <button
        @click.prevent="submit"
        class="tw-bg-eko-orange hover:tw-bg-eko-dark tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
        type="button"
      >
        Update
      </button>
    </div>

    <vue-element-loading
      v-if="loading"
      :active="loading"
      :is-full-screen="true"
    />
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      user: {},
      error: false,
      loading: false,
      token: "",
      data: {},
      errors: {},
      conf_password: "",
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
  },
  methods: {
    submit() {
      this.loading = false;
      this.success = false;
      this.errors = {};
      let deny = false;

      if (!this.data.oldPassword) {
        this.errors.oldPassword = true;
        deny = true;
      }

      if (!this.data.newPassword) {
        this.errors.newPassword = true;
        deny = true;
      }
      if (this.data.newPassword !== this.conf_password) {
        this.errors.conf_password = true;
        deny = true;
      }

      if (deny) {
        return;
      }
      const self = this;
      self.loading = true;
      axios
        .post(`${this.$baseUrl}/user/change-password`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          self.loading = false;
          localStorage.setItem("eko-carbon-token", response.data.token);
          localStorage.setItem(
            "eko-carbon-user",
            JSON.stringify(response.data.user)
          );

          this.token = localStorage.getItem("eko-carbon-token");
          this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
          self.$swal("Success!", "Password  changed successfully", "success");
          this.data = {};
          this.conf_password = "";
        })
        .catch((error) => {
          console.log(error.response);
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}

.my-img {
  width: 50%;
  height: 50%;
  margin: auto;
}
</style>
